module.exports = __webpack_public_path__ + "img/2025-07-21a_11.8716bb8d.jpg";